import { userRequests } from '../requests/users.request';
import { createApiThunk } from '../utils/api-thunk';

export const getUsersByIds = createApiThunk(userRequests.getUsersByIds);

